import {adminRole} from "../../../core/access-roles/admin.role";
import {employeeRole} from "../../../core/access-roles/employee.role";
import {customerRole} from "../../../core/access-roles/customer.role";
import {externalRole} from "../../../core/access-roles/external.role";

export interface RoleModel {
  name: string
  nameDutch: string
    employee: {
        view: boolean;
        add: boolean;
        edit: boolean;
        delete: boolean;
    };
    customer: {
        view: boolean;
        add: boolean;
        edit: boolean;
        delete: boolean;
        addUser: boolean;
        editUser: boolean;
    };
    project: {
        view: boolean;
        others: boolean;
    };
    firePartition: {
        view: boolean;
    };
    printQr: {
        view: boolean;
        generate: boolean;
    }
}

 function isAdmin(roles: string[]): boolean {
  return roles.includes(adminRole.name)
}

function isEmployee(roles: string[]): boolean {
  return  roles.includes(employeeRole.name)
}

function isCustomer(roles: string[]): boolean {
  return roles.includes(customerRole.name)
}

function isExternal(roles: string[]): boolean {
  return roles.includes(externalRole.name)
}

export function getRoleModel(roles: string[]) {
  if (isAdmin(roles)) {
    return adminRole
  }
  if (isEmployee(roles)) {
    return employeeRole
  }
  if (isCustomer(roles)) {
    return customerRole
  }
  if (isExternal(roles)) {
    return externalRole
  }
  throw new Error('Unsupported roles: ' + roles)
}
